export const SET_SHOW_CROP_MODAL = '@modal/setShowCropModal'
export const SET_CROPPED_IMAGE = '@modal/setCroppedImage'
